import styled from 'styled-components';
import { rem } from '@/styles/theme';

interface IProps {
  theme: any;
  color?: string;
}

export const Divider = styled.div<IProps>`
  height: ${rem(12)};
  background: ${({ theme, color = 'gray-200' }) => theme.color[color]};
`;
